import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import QtModal from "../../../components/Modal/QtModal";
import ArModal from "../../../components/Modal/ArModal";
import ItemForSaleTable from "../../../components/Content/ItemForSaleTable";
import Summary from "../../../components/Footer/Summary";
import DatePicker from "../../../components/DatePicker";
import FormAction from "../../../components/Actions/FormAction";
import PaymentModal from "../../../components/Modal/PaymentModal";
import EmployeeModal from "../../../components/Modal/EmployeeModal";

// Model
import { soMasterModel } from "../../../../model/SellProducts/SoMasterModel";
import { soDetailModel } from "../../../../model/SellProducts/SoDetailModel";

// Utils
import {
  getData,
  getDataWithComp,
  getByDocId,
  getDocType,
  getTransType,
  getAlert,
  formatCurrency,
  parseCurrency,
  deleteData,
  getDataWithJoin,
  createSetRecNo,
  getMaxRecNoForTest,
  getSpRunNumber,
  uploadSlip,
  uploadMultipleSlips,
  getPriceForIce,
  getDiscountForIce,
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
  formatDate,
  convertDate,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import {
  manageWhArPaymentData,
  setRemarkByPaymentType,
} from "../../../../utils/PaymentUtils";
import { manageItemRemainData } from "../../../../utils/RemainUtils";

function Form({ callInitialize, mode, setMode, name, maxDocNo, getReport }) {
  const [formMasterList, setFormMasterList] = useState(soMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [qtDataList, setQtDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [empDataList, setEmpDataList] = useState([]);
  const [showEmpModal, setShowEmpModal] = useState(false);
  const [invDeptId, setInvDeptId] = useState(null);
  const [invDeptName, setInvDeptName] = useState("");

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] = useState("1");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // การแสดงสถานะเอกสาร
  const [statusTransportName, setStatusTransportName] = useState("");
  const [statusTransportColour, setStatusTransportColour] = useState("");
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");
  const [statusPaidTypeName, setStatusPaidTypeName] = useState("");
  const [statusPaidTypeColour, setStatusPaidTypeColour] = useState("");

  // สำหรับเก็บประเภทการชำระเงิน
  const [paymentType, setPaymentType] = useState({});
  const [paymentAmount, setPaymentAmount] = useState({});
  const [payDatetime, setPayDatetime] = useState(moment());

  // เก็บตัวแปรสำหรับเช็ค
  const [chequeNo, setChequeNo] = useState("");
  const [chequeName, setChequeName] = useState("");
  const [chequeBranch, setChequeBranch] = useState("");
  const [chequeDate, setChequeDate] = useState(moment());

  // เก็บตัวแปรสำหรับธนาคาร
  const [bankMasterId, setBankMasterId] = useState("2");
  const [bankId, setBankId] = useState("");
  const [bankInputMode, setBankInputMode] = useState("select"); // "select" หรือ "manual"
  const [payToAccNo, setPayToAccNo] = useState("");
  const [payToAccName, setPayToAccName] = useState("");

  const [base64Image, setBase64Image] = useState("");

  // สำหรับเช็กเงื่อนไขว่าสร้างวางบิลหรือยัง ?
  const [isBl, setIsBl] = useState(false);

  // สำหรับตัวแปรดักป้องกันการกดซ้ำ
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // สำหรับเช็คว่าเป็นค้างจ่ายที่สามารถให้เลือกเป็นเครดิตได้
  const [isAllowCredit, setIsAllowCredit] = useState(false);

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);

  // สำหรับตรวจสอบว่ามีการแก้ไข Detail หรือไม่
  const [isEditDetail, setIsEditDetail] = useState(false);

  // สำหรับเก็บสลิป
  const [slipImage, setSlipImage] = useState("");
  const [multipleSlipImages, setMultipleSlipImages] = useState([]);
  const [isUploadingSlips, setIsUploadingSlips] = useState(false);

  // เก็บไว้ว่าเป็น ราคาขาย หรือ ราคาขายส่ง
  const [itemPriceType, setItemPriceType] = useState("IP"); // IP = ราคาขาย, IWP = ราคาขายส่ง

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      // เคลียร์ค่าทุกครั้งที่เปิดหน้าจอมา (แก้ปัญหา List ข้อมูลชอบค้าง)
      setFormMasterList(soMasterModel());
      setFormDetailList([]);

      // Start every request together, but do not hold the customer selector
      // hostage to slower product, warehouse, or quotation requests.
      const arDataPromise = getDataWithComp("Tb_Set_AR", "ORDER BY AR_Code ASC");
      const initialDataPromise = Promise.all([
        getDocType(2),
        getTransType(),
        Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-qt-by-so`,
          { comp_id: window.localStorage.getItem("company") },
          { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
        ),
        getDataWithJoin(
          `item.*`,
          `Tb_Set_Item item`,
          `
            LEFT JOIN Tb_Set_ItmGroup grp ON (grp.Group_Id = item.Item_Group)
            WHERE item.Comp_Id = ${localStorage.getItem("company")}
            AND grp.Comp_Id = ${localStorage.getItem("company")}
            AND grp.Group_Code = 'G'
          `,
          `ORDER BY item.Item_Code ASC`
        ),
        getDataWithComp("Tb_Set_Wh", `AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`),
        getDataWithComp("View_Set_Employee", `AND Emp_Status = 'Y' ORDER BY Emp_Code ASC`),
      ]);

      const arDataList = await arDataPromise;
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const [docTypeList, transTypeList, qtResponse, itemDataList, whDataList, empData] = await initialDataPromise;

      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      if (qtResponse.data && qtResponse.data.length > 0) {
        setQtDataList(qtResponse.data);
      }


      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      if (empData && empData.length > 0) {
        setEmpDataList(empData);
      }
      // Default จำนวนการชำระไว้ก่อนเป็น 0.00
      setPaymentAmount({
        cash: "0.00",
        transfer: "0.00",
        cheque: "0.00",
        credit: "0.00",
        unpaid: "0.00",
      });

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(arDataList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      const findMaster = await getDataWithComp("SO_H", `AND Doc_No = '${maxDocNo}'`);
      const fromDatabase = findMaster && findMaster.length > 0 ? findMaster[0] : null;

      if (!fromDatabase) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase.AR_ID
      );

      if (!fromViewAr) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0701_SO_H", `AND Doc_No = '${maxDocNo}'`);
      const fromView = findViewMaster && findViewMaster.length > 0 ? findViewMaster[0] : null;
      if (!fromView) {
        throw new Error("ไม่พบข้อมูล VIEW ของเอกสารที่เลือก");
      }
      setStatusTransportName(fromView.DocStatusTransport_Name);
      setStatusTransportColour(fromView.DocStatusTransport_Colour);
      setStatusPaidName(fromView.DocStatusPaid_Name);
      setStatusPaidColour(fromView.DocStatusPaid_Colour);
      setStatusPaidTypeName(fromView.DocStatusPaid_Type_Name);
      setStatusPaidTypeColour(fromView.DocStatusPaidType_Colour);

      // สำหรับเช็กเงื่อนไขว่าสร้างวางบิลหรือยัง ?
      const findBlBySoId = await getData(
        "BL_D",
        `SO_Id = ${fromDatabase.Doc_Id}`
      );
      if (findBlBySoId && findBlBySoId.length > 0) {
        setIsBl(true);
      }

      // ฟังก์ชันเพื่อดึงข้อมูล itemOnHand และอัปเดตทีหลัง
      const updateItemOnHandLater = async (newRow, whId, itemId, itemQty) => {
        try {
          // ดึงข้อมูลทั้งหมดในครั้งเดียว
          const [itemOnHandData] = await Promise.all([
            getDataWithComp(
              "API_1101_WH_ITEM_ONHAND",
              `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(
                itemId
              )}`
            ),
          ]);

          if (!itemOnHandData || itemOnHandData.length === 0) {
            newRow.itemOnHand = parseCurrency(itemQty) || 0;
          } else {
            let newItemOnHand = parseCurrency(itemOnHandData[0].Item_Onhand);
            newItemOnHand += parseCurrency(itemQty) || 0;
            newRow.itemOnHand = newItemOnHand;
          }

          // อัปเดต UI
          setFormDetailList((prevDetails) =>
            prevDetails.map((detail) =>
              detail.itemId === newRow.itemId
                ? { ...detail, itemOnHand: newRow.itemOnHand }
                : detail
            )
          );
        } catch (error) {
          setIsLoading(false);
          getAlert("FAILED", error.message || error);
        }
      };

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        itemTotal -=
          itemDisType === "2"
            ? (itemDiscount / 100) * itemTotal // ลดตามเปอร์เซ็นต์
            : itemDiscount; // ลดตามจำนวนเงิน

        const newRow = {
          ...soDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType,
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          dsSeq: itemSelected.DS_SEQ,
          whId: itemSelected.WH_Id,
          itemRecQty: formatCurrency(itemSelected.Item_Rec_Qty),
          itemOnHand: "-",
        };

        if (itemSelected.WH_Id != null) {
          updateItemOnHandLater(
            newRow,
            itemSelected.WH_Id,
            itemSelected.Item_Id,
            itemQty
          );
        }

        return newRow; // ส่ง newRow กลับทันที
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "SO_D",
        fromDatabase.Doc_Id,
        `ORDER BY Line ASC`
      );

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);

        setFormMasterList({
          docId: fromDatabase.Doc_Id,
          compId: fromDatabase.Comp_Id,
          docNo: fromDatabase.Doc_No,
          docDate: convertDate(fromDatabase.Doc_Date, false) || null,
          docStatus: fromDatabase.Doc_Status,
          docStatusTransport: fromDatabase.Doc_Status_Transport,
          docStatusReceive: fromDatabase.Doc_Status_Receive,
          docStatusPaid: fromDatabase.Doc_Status_Paid,
          docStatusPaidType: fromDatabase.Doc_Status_Paid_Type,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          docIsPickingList: fromDatabase.Doc_Is_PickingList,
          docIsInv: fromDatabase.Doc_Is_INV,
          docInvNo: fromDatabase.Doc_INV_No,
          docIsInvFrom: fromDatabase.Doc_Is_INV_From,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: convertDate(fromDatabase.Ref_DocDate) || null,
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          arID: fromDatabase.AR_ID,
          arCode: fromDatabase.AR_Code,
          docDueDate: convertDate(fromDatabase.Doc_DueDate, false) || null,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,
          payTotal: fromDatabase.Pay_Total,
          refBillNo: fromDatabase.Ref_Bill_No,
          docSoReceiveDate: formatDate(
            fromDatabase.Doc_SO_Receive_Date || null
          ),
          arName: fromViewAr.AR_Name,
          arAdd1: fromViewAr.AR_Add1,
          arAdd2: fromViewAr.AR_Add2,
          arAdd3: fromViewAr.AR_Add3,
          arProvince: fromViewAr.AR_Province,
          arZipcode: fromViewAr.AR_Zipcode,
          arTaxNo: fromViewAr.AR_TaxNo,
          invId:
            fromDatabase.Inv_Id ||
            fromDatabase.InvID ||
            fromDatabase.InvID ||
            fromDatabase.Inv_Id ||
            null,
          invCode: fromDatabase.Inv_Code || fromDatabase.InvCode || null,
          invName: fromDatabase.Inv_Name || fromDatabase.InvName || null,
          invDeptId:
            fromDatabase.Inv_Dept_Id || fromDatabase.Inv_DeptId || null,
          invDeptName: fromDatabase.Inv_Dept_Name || fromDatabase.InvDeptName || null,
        });

        setInvDeptId(
          fromDatabase.Inv_Dept_Id || fromDatabase.Inv_DeptId || null
        );
        setInvDeptName(
          fromDatabase.Inv_Dept_Name || fromDatabase.Inv_DeptName || ""
        );

        // ค้นหารูปสลิปกรณีที่เป็นโอน
        if (fromDatabase.Doc_Status_Paid_Type === 2) {
          const fromSlip = await getData(
            "Upload_File_List",
            `DocCode_Id = 7 AND Doc_ID = ${fromDatabase.Doc_Id}`
          );
          if (fromSlip && fromSlip.length > 0) {
            setSlipImage(fromSlip[0].File_Url);
          }
        }

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(
          fromDatabase.Discount_Value_Type
        );
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }

        setSelectedDiscountValueType(String(fromDatabase.Discount_Value_Type));

        // กำหนดประเภทการจ่ายต่อ กรณีที่ค้างจ่าย
        if (fromDatabase.Doc_Status_Paid === 2) {
          const payHistory = await getData(
            "Pay_History",
            `DocCode_Id = 7 AND Pay_Type = ${fromDatabase.Doc_Status_Paid_Type} AND Doc_Id = ${fromDatabase.Doc_Id}`
          );
          if (payHistory && payHistory.length > 0) {
            setPayDatetime(moment(payHistory[0].Pay_Datetime));
          }

          switch (fromDatabase.Doc_Status_Paid_Type) {
            // ถ้าเป็น 1 คือ เงินสด
            case 1:
              setPaymentType({
                cash: true,
                transfer: false,
                cheque: false,
                credit: false,
                unpaid: false,
              });
              setPaymentAmount({
                cash: formatCurrency(fromDatabase.Pay_Total),
                transfer: "0.00",
                cheque: "0.00",
                credit: "0.00",
                unpaid: "0.00",
              });
              break;

            // ถ้าเป็น 2 คือ เงินโอน
            case 2:
              setPaymentType({
                cash: false,
                transfer: true,
                cheque: false,
                credit: false,
                unpaid: false,
              });
              setPaymentAmount({
                cash: "0.00",
                transfer: formatCurrency(fromDatabase.Pay_Total),
                cheque: "0.00",
                credit: "0.00",
                unpaid: "0.00",
              });
              break;

            // ถ้าเป็น 3 คือ เช็ค
            case 3:
              setPaymentType({
                cash: false,
                transfer: false,
                cheque: true,
                credit: false,
                unpaid: false,
              });
              setPaymentAmount({
                cash: "0.00",
                transfer: "0.00",
                cheque: formatCurrency(fromDatabase.Pay_Total),
                credit: "0.00",
                unpaid: "0.00",
              });

              const payHistoryForCheque = await getData(
                "Pay_History",
                `DocCode_Id = 7 AND Pay_Type = 3 AND Doc_Id = ${fromDatabase.Doc_Id}`
              );
              if (payHistoryForCheque && payHistoryForCheque.length > 0) {
                const payData = payHistoryForCheque[0];
                setChequeNo(payData.Pay_Cheque_No);
                setChequeName(payData.Pay_Cheque_Name);
                setChequeBranch(payData.Pay_Cheque_Branch);
                setChequeDate(payData.Pay_Cheque_date);
              }

              break;

            // ถ้าเป็น 4 คือ เครดิต
            case 4:
              setPaymentType({
                cash: false,
                transfer: false,
                cheque: false,
                credit: true,
                unpaid: false,
              });
              setPaymentAmount({
                cash: "0.00",
                transfer: "0.00",
                cheque: "0.00",
                credit: formatCurrency(fromView.NetTotal),
                unpaid: "0.00",
              });
              break;

            // ถ้าเป็น 5 คือ ค้างจ่าย
            case 5:
              setPaymentType({
                cash: false,
                transfer: false,
                cheque: false,
                credit: false,
                unpaid: true,
              });
              setPaymentAmount({
                cash: "0.00",
                transfer: "0.00",
                cheque: "0.00",
                credit: "0.00",
                unpaid: formatCurrency(fromView.NetTotal),
              });
              setIsAllowCredit(fromDatabase.IsVat === 1 ? true : false);
              break;

            // ถ้าเป็น 6 แปลว่าจ่ายหลายช่องทาง ต้องไปค้นหาที่ Table : Pay_History เพิ่ม
            case 6:
              const paymentHistoryResponse = await getData(
                "Pay_History",
                `DocCode_Id = 7 AND Doc_Id = ${fromDatabase.Doc_Id}`
              );
              if (paymentHistoryResponse && paymentHistoryResponse.length > 0) {
                // Loop ผ่านข้อมูลการจ่ายหลายช่องทาง
                for (const payment of paymentHistoryResponse) {
                  switch (payment.Pay_Type) {
                    // ถ้า payment.Pay_Type === 1 คือ เงินสด
                    case 1:
                      setPaymentType((prev) => ({
                        ...prev,
                        cash: true,
                      }));
                      setPaymentAmount((prev) => ({
                        ...prev,
                        cash: formatCurrency(payment.Pay_Amount),
                      }));
                      break;

                    // ถ้า payment.Pay_Type === 2 คือ เงินโอน
                    case 2:
                      setPaymentType((prev) => ({
                        ...prev,
                        transfer: true,
                      }));
                      setPaymentAmount((prev) => ({
                        ...prev,
                        transfer: formatCurrency(payment.Pay_Amount),
                      }));
                      break;

                    // ถ้า payment.Pay_Type === 3 คือ เช็ค
                    case 3:
                      setPaymentType((prev) => ({
                        ...prev,
                        cheque: true,
                      }));
                      setPaymentAmount((prev) => ({
                        ...prev,
                        cheque: formatCurrency(payment.Pay_Amount),
                      }));

                      // ถ้าเป็นเช็ค ต้องเซ็ทเลขที่เช็ค ชื่อ และ วันที่แบบนี้ด้วย
                      setChequeNo(payment.Pay_Cheque_No);
                      setChequeName(payment.Pay_Cheque_Name);
                      setChequeBranch(payment.Pay_Cheque_Branch);
                      setChequeDate(payment.Pay_Cheque_date);

                      break;

                    // กรณีที่ไม่ตรงกับ 1, 2, หรือ 3
                    default:
                      console.warn(
                        `พบประเภทการจ่ายที่ไม่รู้จัก: ${payment.Pay_Type}`
                      );
                      break;
                  }
                }
              }
              break;

            // กรณีอื่นๆ ถ้ามี
            default:
              console.log("ประเภทการจ่ายไม่ถูกต้อง");
              break;
          }
        }
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const validateData = async () => {
    // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
    if (!formMasterList.arID && !formMasterList.arCode) {
      setIsSubmitting(false);
      setIsLoading(false);
      getAlert("FAILED", "กรุณาเลือกลูกค้า");
      return false; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
    }

    // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
    if (!formDetailList || formDetailList.length === 0) {
      setIsSubmitting(false);
      setIsLoading(false);
      getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
      return false; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
    }

    // ตรวจสอบค่าภายใน formDetailList
    let index = 0;
    for (const item of formDetailList) {
      // ทำการตรวจสอบจำนวนสินค้าที่สามารถขายได้อีกรอบ
      // await handleChangeDetail(index, "whId", item.whId);

      if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
        return false; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
      }
      if (
        formMasterList.arItemFree !== "Y" &&
        (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0)
      ) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
        return false; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
      }
      if (!item.whId) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
        );
        return false; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
      }
      if (parseCurrency(item.itemQty) > parseCurrency(item.itemOnHand)) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert(
          "FAILED",
          `จํานวนสินค้า ${item.itemName} ไม่พอ กรุณาทำรายการใหม่`
        );
        return false; // หยุดการทำงานหากจํานวนสินค้ามากกว่าจํานวนคงเหลือ
      }

      index++;
    }

    return true;
  };

  // เพิ่มฟังก์ชันสำหรับจัดการ multiple slip upload
  const handleMultipleSlipUpload = (event) => {
    const files = Array.from(event.target.files);

    if (files.length > 10) {
      getAlert("FAILED", "สามารถอัพโหลดได้ไม่เกิน 10 ไฟล์");
      event.target.value = "";
      return;
    }

    if (multipleSlipImages.length + files.length > 10) {
      getAlert(
        "FAILED",
        `สามารถอัพโหลดได้ไม่เกิน 10 ไฟล์ (ปัจจุบันมี ${multipleSlipImages.length} ไฟล์)`
      );
      event.target.value = "";
      return;
    }

    const newImages = [];
    let processedFiles = 0;

    files.forEach((file, index) => {
      if (file.size > 5 * 1024 * 1024) {
        getAlert("FAILED", `ไฟล์ ${file.name} มีขนาดใหญ่เกิน 5MB`);
        return;
      }

      if (
        file &&
        (file.type.startsWith("image/") || file.type === "application/pdf")
      ) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const base64 = e.target.result;
          newImages.push({
            id: Date.now() + index,
            base64: base64,
            name: file.name,
            type: file.type,
          });

          processedFiles++;

          if (processedFiles === files.length) {
            setMultipleSlipImages((prev) => [...prev, ...newImages]);
            if (base64Image) {
              setBase64Image("");
            }
          }
        };

        reader.onerror = () => {
          getAlert("FAILED", `ไม่สามารถอ่านไฟล์ ${file.name} ได้`);
        };

        reader.readAsDataURL(file);
      } else {
        getAlert("FAILED", `ไฟล์ ${file.name} ไม่ใช่รูปภาพหรือ PDF ที่รองรับ`);
      }
    });

    event.target.value = "";
  };

  const handleRemoveSlipImage = (imageId) => {
    setMultipleSlipImages((prev) => prev.filter((img) => img.id !== imageId));
  };

  const handleClearAllSlips = () => {
    setMultipleSlipImages([]);
    setBase64Image("");
    const fileInput = document.getElementById("multipleFileInput");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleSubmit = async (
    docStatusPaid,
    docStatusPaidType,
    totalPaidAmount
  ) => {
    if (isSubmitting) return getAlert("FAILED", "กรุณารอสักครู่");
    setIsSubmitting(true);

    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      let newMaxDoc = "UNKNOWN"; // กำหนดค่าเริ่มต้น
      let newMaxRec = null; // กำหนดค่าเริ่มต้น
      let newDateRec = null; // กำหนดค่าเริ่มต้น

      if (paymentType.credit) {
        // กรณีลูกค้าขายเชื่อ
        if (isVatChecked) {
          // VAT
          newMaxDoc = await getSpRunNumber("INV");
        } else {
          // ไม่ VAT
          newMaxDoc = await getSpRunNumber("DSR");
        }
      } else {
        // กรณีลูกค้าขายสด
        if (isVatChecked) {
          // VAT
          newMaxDoc = await getSpRunNumber("INV");

          // ทำการสร้างใบเสร็จรับเงิน และ รันเลข REC ที่ Tb_Set_Rec_No ล่าสุด
          const findMaxRecNo = await getData(
            "Tb_Set_Rec_No",
            `1 = 1 ORDER BY RecNo DESC`
          );
          newMaxRec = getMaxRecNoForTest(findMaxRecNo);
          newDateRec = getCreateDateTime();
          await createSetRecNo(newMaxRec);
        } else {
          // ไม่ VAT
          newMaxDoc = await getSpRunNumber("CS");
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: newMaxDoc,
        doc_date: convertDate(formMasterList.docDate, true),
        doc_status: parseCurrency("2"),
        doc_status_transport: parseCurrency("3"),
        doc_status_receive: parseCurrency("3"),
        doc_status_paid: parseCurrency(docStatusPaid),
        doc_status_paid_type: parseCurrency(docStatusPaidType),
        doc_code: parseCurrency("7"),
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_picking_list: 0,
        doc_is_inv: "N",
        doc_inv_no: newMaxRec,
        doc_is_inv_from: parseCurrency("0"),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseCurrency(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        doc_due_date: convertDate(formMasterList.docDueDate, true),
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: formMasterList.creditTerm1Day,
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        inv_id: parseCurrency(formMasterList.invId || 0, 10),
        inv_code: formMasterList.invCode || null,
        inv_name: formMasterList.invName || null,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: formMasterList.updateByName,
        update_by_id: formMasterList.updateById,
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: "N",
        printed_date: formMasterList.printedDate,
        printed_by: formMasterList.printedBy,
        pay_total: parseCurrency(
          paymentType.credit || paymentType.unpaid ? "0" : totalPaidAmount
        ),
        ref_bill_no: formMasterList.refBillNo,
        doc_so_receive_date: newDateRec
          ? formatThaiDateUiToDate(newDateRec)
          : null,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "SO_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        // ส่งข้อมูลรายละเอียดหากพบ Doc_Id
        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              doc_id: parseCurrency(docId, 10),
              line: index + 1,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_discount: parseCurrency(item.itemDiscount),
              item_distype:
                item.itemDisType === "1"
                  ? parseCurrency("1", 10)
                  : parseCurrency("2", 10),
              item_total: parseCurrency(item.itemTotal),
              item_status: parseCurrency("1", 10),
              ds_seq: item.dsSeq,
              wh_id: item.whId,
              item_rec_qty: parseCurrency("0"),
            };

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-so-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);

          await Promise.all(
            formDetailList.map((item) =>
              manageWhItemData(
                item.itemId,
                item.itemCode,
                item.itemName,
                item.whId,
                "OUT",
                parseCurrency(item.itemQty),
                docId,
                formMasterData.doc_no,
                formMasterData.ref_doc === null
                  ? formMasterData.doc_no
                  : formMasterData.ref_doc,
                "ขายสินค้า"
              )
            )
          );

          const paymentTypeMap = {
            cash: 1,
            transfer: 2,
            cheque: 3,
            credit: 4,
            unpaid: 5,
            fee: 7,
          };

          // Create pay history entries in parallel
          const payPromises = [];
          for (const method of Object.keys(paymentType)) {
            if (
              paymentType[method] &&
              parseCurrency(paymentAmount[method]) > 0 &&
              (paymentTypeMap[method] === 1 ||
                paymentTypeMap[method] === 2 ||
                paymentTypeMap[method] === 3 ||
                paymentTypeMap[method] === 7)
            ) {
              let bank_master_id_val = null;
              let bank_id_val = null;
              let pay_to_acc_no_val = null;
              let pay_to_acc_name_val = null;

              if (method === "transfer" || method === "cheque") {
                if (bankInputMode === "manual" || method === "cheque") {
                  bank_master_id_val = bankMasterId || null;
                  pay_to_acc_no_val = payToAccNo || null;
                  pay_to_acc_name_val = payToAccName || null;
                } else if (bankInputMode === "select") {
                  bank_id_val = bankId || null;
                }
              }

              const formPaymentHistoryData = {
                doc_code_id: 7,
                doc_id: getDocIdResponse.data[0].Doc_Id,
                pay_type: paymentTypeMap[method],
                pay_amount:
                  docStatusPaidType === 6
                    ? parseCurrency(paymentAmount[method])
                    : parseCurrency(totalPaidAmount),
                pay_remark: null,
                pay_datetime: moment(paymentTypeMap[method] === 3 ? chequeDate : payDatetime)
                  .utcOffset(7, true)
                  .format("YYYY-MM-DD HH:mm:ss.SSS"),
                pay_by: localStorage.getItem("name"),
                pay_to_acc_no: pay_to_acc_no_val,
                pay_to_branch: null,
                pay_to_acc_name: pay_to_acc_name_val,
                pay_cheque_no: paymentTypeMap[method] === 3 ? chequeNo : null,
                pay_cheque_name:
                  paymentTypeMap[method] === 3 ? chequeName : null,
                pay_cheque_branch:
                  paymentTypeMap[method] === 3
                    ? chequeBranch || "ธนาคารกสิกรไทย"
                    : null,
                pay_cheque_date:
                  paymentTypeMap[method] === 3
                    ? moment(chequeDate)
                      .utcOffset(7, true)
                      .format("YYYY-MM-DD HH:mm:ss.SSS")
                    : null,
                pay_cheque_type: null,
                comp_id: localStorage.getItem("company"),
                bank_master_id: bank_master_id_val,
                bank_id: bank_id_val,
                doc_ref: null,
              };

              payPromises.push(
                Axios.post(
                  `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
                  formPaymentHistoryData,
                  { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
                )
              );
            }
          }

          if (payPromises.length > 0) await Promise.all(payPromises);

          // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
          const getOldData = await getDataWithComp(
            "API_0701_SO_H",
            `AND Doc_ID = ${docId}`
          );
          if (getOldData && getOldData.length > 0) {
            const data = getOldData[0];
            // ปรับยอดเงินออก (เริ่มต้น)
            await manageWhArPaymentData(
              data.AR_ID, // AR_ID ของลูกค้านั้นๆ
              data.AR_Code, // AR_Code ของสิ่งนั้นๆ
              data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
              0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
              "AO", // ประเภท เช่น AI/AO
              parseCurrency(data.NetTotal), // ค่าจำนวนเงิน
              data.Doc_ID, // ไอดีเอกสาร
              data.Doc_No, // เลขเอกสาร
              data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
              null, // หมายเหตุ
              paymentType.credit ? parseCurrency("4") : parseCurrency("5") // ช่องทางการชำระ
            );

            if (
              paymentType.cash ||
              paymentType.transfer ||
              paymentType.cheque
            ) {
              if (data.Doc_Status_Paid_Type === 6) {
                const getPayHistory = await getData(
                  "Pay_History",
                  `DocCode_Id = 7 AND Doc_Id = ${formMasterList.docId}`
                );
                if (getPayHistory && getPayHistory.length > 0) {

                  const remarkPromises = getPayHistory.map((pay) =>
                    setRemarkByPaymentType(parseCurrency(pay.Pay_Type))
                  );
                  const remarks = await Promise.all(remarkPromises);

                  await Promise.all(
                    getPayHistory.map((pay, idx) =>
                      manageWhArPaymentData(
                        data.AR_ID,
                        data.AR_Code,
                        data.AR_Name,
                        0,
                        "AI",
                        parseCurrency(data.Pay_Amount),
                        data.Doc_ID,
                        data.Doc_No,
                        data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc,
                        remarks[idx],
                        parseCurrency(pay.Pay_Type)
                      )
                    )
                  );
                }
              } else {
                // ปรับยอดเงินออก
                await manageWhArPaymentData(
                  data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                  data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                  data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                  0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                  "AI", // ประเภท เช่น AI/AO
                  parseCurrency(data.Pay_Total), // ค่าจำนวนเงิน
                  data.Doc_ID, // ไอดีเอกสาร
                  data.Doc_No, // เลขเอกสาร
                  data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
                  await setRemarkByPaymentType(
                    parseCurrency(data.Doc_Status_Paid_Type)
                  ), // หมายเหตุ
                  parseCurrency(data.Doc_Status_Paid_Type) // ช่องทางการชำระ
                );
              }
            }
          }

          if (paymentType.transfer) {
            try {
              setIsUploadingSlips(true);

              // ตรวจสอบว่ามีการใช้ multiple slips หรือไม่
              if (multipleSlipImages && multipleSlipImages.length > 0) {
                // ใช้ uploadMultipleSlips สำหรับหลายไฟล์
                const slipFiles = multipleSlipImages.map(
                  (image) => image.base64
                );
                await uploadMultipleSlips(slipFiles, docId, 7);
              } else if (base64Image) {
                // Backward compatibility สำหรับไฟล์เดียว
                await uploadSlip(base64Image, docId, 7);
                console.log(`✅ Uploaded single slip file successfully`);
              }
            } catch (uploadError) {
              console.error("❌ Error uploading slips:", uploadError);
              // ไม่ให้การอัพโหลดสลิปผิดพลาดทำให้การบันทึกล้มเหลว
              getAlert(
                "WARNING",
                "บันทึกข้อมูลสำเร็จ แต่การอัพโหลดสลิปมีปัญหา: " +
                uploadError.message
              );
            } finally {
              setIsUploadingSlips(false);
            }
          }
        }
      }

      setMode("S");
      callInitialize();
      getAlert("OK", "บันทึกรายการใบขายสำเร็จ");
    } catch (error) {
      setIsSubmitting(false);
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
    }
  };

  const [showPayTypeModal, setShowPayTypeModal] = useState(false);
  const handlePayTypeShow = () => setShowPayTypeModal(true);
  const handlePayTypeClose = async () => {
    setShowPayTypeModal(false);
    setPaymentType({});
    setPaymentAmount({});

    if (mode === "U") {
      setIsLoading(true);
      await initialize();
    }
  };

  // SET EMP (ผู้ทำการขาย)
  const handleEmpShow = () => setShowEmpModal(true);
  const handleEmpClose = () => setShowEmpModal(false);
  const getDepartmentForEmp = async (empId) => {
    try {
      const department = await getDataWithComp(
        "View_Set_Employee",
        `AND Emp_Id = ${empId}`
      );

      if (department && department.length > 0) {
        const row = department[0];

        let deptId =
          row.Dept_Id ?? row.DeptID ?? row.Dept_ID ?? row.DeptId ?? null;
        let deptName = row.Dept_Name ?? row.DeptName ?? row.Dept ?? null;

        if (!deptId) {
          for (const [k, v] of Object.entries(row)) {
            if (/dept/i.test(k) && v != null && v !== "") {
              const n = Number(v);
              if (!Number.isNaN(n)) {
                deptId = n;
                break;
              } else {
                deptId = v;
                break;
              }
            }
          }
        }

        if (!deptName) {
          for (const [k, v] of Object.entries(row)) {
            if (/dept.*name/i.test(k) && v) {
              deptName = v;
              break;
            }
          }
        }

        if (deptId) setInvDeptId(deptId);
        if (deptName) setInvDeptName(deptName);
        return deptId ?? null;
      }
      return null;
    } catch (error) {
      getAlert("FAILED", error);
      return null;
    }
  };

  const onRowSelectEmp = async (empSelected) => {
    try {
      setFormMasterList((prev) => ({
        ...prev,
        invId: empSelected.Emp_Id,
        invCode: empSelected.Emp_Code,
        invName: empSelected.Emp_Name,
      }));

      // ค้นหาแผนกผู้ทำการขาย
      await getDepartmentForEmp(empSelected.Emp_Id);
      handleEmpClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleUpdate = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        if (!item.whId) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        }
      }

      // ถ้าเข้ามาแก้ไขใบค้างจ่าย
      if (mode === "U" && paymentType.unpaid) {
        const getOldData = await getDataWithComp(
          "API_0701_SO_H",
          `AND Doc_ID = ${formMasterList.docId}`
        );
        if (getOldData && getOldData.length > 0) {
          const data = getOldData[0];
          // ปรับยอดเงินเข้า
          await manageWhArPaymentData(
            data.AR_ID, // AR_ID ของลูกค้านั้นๆ
            data.AR_Code, // AR_Code ของสิ่งนั้นๆ
            data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
            0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
            "AI", // ประเภท เช่น AI/AO
            parseCurrency(data.NetTotal), // ค่าจำนวนเงิน
            data.Doc_ID, // ไอดีเอกสาร
            data.Doc_No, // เลขเอกสาร
            data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
            null, // หมายเหตุ
            null // ช่องทางการชำระ
          );
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: formMasterList.docNo,
        doc_date: convertDate(formMasterList.docDate, true),
        doc_status: formMasterList.docStatus,
        doc_status_transport: formMasterList.docStatusTransport,
        doc_status_receive: formMasterList.docStatusReceive,
        doc_status_paid: parseCurrency(formMasterList.docStatusPaid, 10),
        doc_status_paid_type: parseCurrency(
          formMasterList.docStatusPaidType,
          10
        ),
        doc_code: formMasterList.docCode,
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_picking_list: formMasterList.docIsPickingList,
        doc_is_inv: formMasterList.docIsInv,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: formMasterList.arID,
        ar_code: formMasterList.arCode,
        doc_due_date: convertDate(formMasterList.docDueDate, true),
        action_hold: formMasterList.actionHold,
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: formMasterList.discountCash,
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: formMasterList.discountTransport,
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: formMasterList.creditTerm1Day,
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: formMasterList.printedStatus,
        printed_date: formatThaiDateUiToDate(formMasterList.printedDate),
        printed_by: formMasterList.printedBy,
        pay_total: formMasterList.payTotal,
        ref_bill_no: formMasterList.refBillNo,
        doc_so_receive_date: formatThaiDateUiToDate(
          formMasterList.docSoReceiveDate
        ),
        inv_id: parseCurrency(formMasterList.invId || 0, 10),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const docId = parseCurrency(formMasterList.docId, 10);

        // ค้นหาใบขายใหม่อีกที
        if (isEditDetail) {
          const getOldSoDetail = await getDataWithComp(
            "API_0702_SO_D",
            `AND Doc_ID = ${docId}`
          );
          if (getOldSoDetail && getOldSoDetail.length > 0) {
            await Promise.all(
              getOldSoDetail.map((soDetail) =>
                manageWhItemData(
                  soDetail.Item_Id,
                  soDetail.Item_Code,
                  soDetail.Item_Name,
                  soDetail.WH_Id,
                  "IN",
                  parseCurrency(soDetail.Item_Qty),
                  docId,
                  soDetail.Doc_No,
                  soDetail.Ref_Doc === null ? soDetail.Doc_No : soDetail.Ref_Doc,
                  "แก้ใบขาย"
                )
              )
            );
          }
        }

        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData("SO_D", `WHERE Doc_ID = ${formMasterList.docId}`);

        const detailPromises = formDetailList.map(async (item, index) => {
          const formDetailData = {
            doc_id: parseCurrency(docId, 10),
            line: index + 1,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_discount: parseCurrency(item.itemDiscount),
            item_distype: item.itemDisType,
            item_total: parseCurrency(item.itemTotal),
            item_status: parseCurrency("1"),
            ds_seq: item.dsSeq,
            wh_id: item.whId,
            item_rec_qty: parseCurrency("0"),
          };

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-so-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        if (isEditDetail) {
          await Promise.all(
            formDetailList.map((item) =>
              manageWhItemData(
                item.itemId,
                item.itemCode,
                item.itemName,
                item.whId,
                "OUT",
                parseCurrency(item.itemQty),
                docId,
                formMasterData.doc_no,
                formMasterData.ref_doc === null
                  ? formMasterData.doc_no
                  : formMasterData.ref_doc,
                "ขายสินค้า"
              )
            )
          );
        }

        // เอายอดเดิมก่อนที่จะแก้ไข มาทำการจ่ายคืนสต็อกก่อน
        if (Number(formMasterList.docStatusPaid) === 2) {
          const getOldData = await getDataWithComp(
            "API_0701_SO_H",
            `AND Doc_ID = ${formMasterList.docId}`
          );
          if (getOldData && getOldData.length > 0) {
            const data = getOldData[0];
            // ปรับยอดเงินออก
            await manageWhArPaymentData(
              data.AR_ID, // AR_ID ของลูกค้านั้นๆ
              data.AR_Code, // AR_Code ของสิ่งนั้นๆ
              data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
              0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
              "AO", // ประเภท เช่น AI/AO
              parseCurrency(
                paymentType.unpaid ? data.NetTotal : data.Pay_Total
              ), // ค่าจำนวนเงิน
              data.Doc_ID, // ไอดีเอกสาร
              data.Doc_No, // เลขเอกสาร
              data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
              `แก้ไขการชำระเงินใบขาย : ${data.Doc_No}`, // หมายเหตุ
              paymentType.credit ? parseCurrency("4") : parseCurrency("5") // ช่องทางการชำระ
            );
          }
        }

        if (Number(formMasterList.docStatusPaid) === 3) {
          setMode("S");
          callInitialize();
          getAlert(response.data.status, response.data.message);
        }

        if (Number(formMasterList.docStatusPaidType) === 4) {
          setMode("S");
          callInitialize();
          getAlert(response.data.status, response.data.message);
        }
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };
  const handleUpdatePayment = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่าว่าเลือกประเภทการชำระเงินหรือยัง
      if (!paymentType) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกประเภทการชำระเงิน");
        return; // หยุดการทำงานของฟังก์ชันหากไม่ได้เลือกประเภทการชำระเงิน
      }

      let docStatusPaid;
      const totalPaidAmount =
        (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
        (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
        (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0) +
        (paymentType.credit ? parseCurrency(paymentAmount.credit) : 0) +
        (paymentType.unpaid ? parseCurrency(paymentAmount.unpaid) : 0);

      if (parseCurrency(totalPaidAmount) === 0) {
        getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
        setIsLoading(false);
        return;
      }

      if (paymentType.credit || paymentType.unpaid) {
        docStatusPaid = 2; // ค้างจ่าย
      } else if (parseCurrency(totalPaidAmount) < parseCurrency(grandTotal)) {
        docStatusPaid = 2; // ค้างจ่าย
      } else {
        docStatusPaid = 3; // จ่ายครบ
      }

      // ตรวจสอบช่องทางที่ถูกเลือก
      let docStatusPaidType = 6;
      const selectedMethods = Object.keys(paymentType).filter(
        (method) =>
          paymentType[method] && parseCurrency(paymentAmount[method]) > 0
      );

      if (selectedMethods.length === 1) {
        const method = selectedMethods[0];
        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          credit: 4,
          unpaid: 5,
          fee: 7,
        };
        docStatusPaidType = paymentTypeMap[method] || 6;
      }

      if (mode === "I") {
        await handleSubmit(docStatusPaid, docStatusPaidType, totalPaidAmount);
        setMode("S");
        callInitialize();
        getAlert("OK", "บันทึกรายการใบขายสำเร็จ");
      } else {
        await handleUpdate();

        const formPaidData = {
          doc_status: parseCurrency("2"),
          doc_status_paid: parseCurrency(docStatusPaid),
          doc_status_paid_type: parseCurrency(docStatusPaidType),
          update_date: formatThaiDateUiToDate(getCreateDateTime()),
          update_by_name: window.localStorage.getItem("name"),
          update_by_id: window.localStorage.getItem("emp_id"),
          doc_no: formMasterList.docNo,
          comp_id: window.localStorage.getItem("company"),
          pay_total: parseCurrency(
            paymentType.credit || paymentType.unpaid ? "0" : totalPaidAmount
          ),
        };
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/update-so-paid`,
          formPaidData,
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );
        if (response.data.status === "OK") {
          const docId = parseCurrency(formMasterList.docId, 10);

          const paymentTypeMap = {
            cash: 1,
            transfer: 2,
            cheque: 3,
            credit: 4,
            unpaid: 5,
            fee: 7,
          };

          // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
          await deleteData(
            "Pay_History",
            `WHERE DocCode_Id = 7 AND Doc_Id = ${docId}`
          );

          for (const method of Object.keys(paymentType)) {
            if (
              paymentType[method] &&
              parseCurrency(paymentAmount[method]) > 0 &&
              (paymentTypeMap[method] === 1 ||
                paymentTypeMap[method] === 2 ||
                paymentTypeMap[method] === 3)
            ) {
              let bank_master_id_val = null;
              let bank_id_val = null;
              let pay_to_acc_no_val = null;
              let pay_to_acc_name_val = null;

              if (method === "transfer" || method === "cheque") {
                if (bankInputMode === "manual" || method === "cheque") {
                  bank_master_id_val = bankMasterId || null;
                  pay_to_acc_no_val = payToAccNo || null;
                  pay_to_acc_name_val = payToAccName || null;
                } else if (bankInputMode === "select") {
                  bank_id_val = bankId || null;
                }
              }

              const formPaymentHistoryData = {
                doc_code_id: 7,
                doc_id: docId,
                pay_type: paymentTypeMap[method],
                pay_amount:
                  docStatusPaidType === 6
                    ? parseCurrency(paymentAmount[method])
                    : parseCurrency(totalPaidAmount),
                pay_remark: null,
                pay_datetime: moment(paymentTypeMap[method] === 3 ? chequeDate : payDatetime)
                  .utcOffset(7, true)
                  .format("YYYY-MM-DD HH:mm:ss.SSS"),
                pay_by: localStorage.getItem("name"),
                pay_to_acc_no: pay_to_acc_no_val,
                pay_to_branch: null,
                pay_to_acc_name: pay_to_acc_name_val,
                pay_cheque_no: paymentTypeMap[method] === 3 ? chequeNo : null,
                pay_cheque_name:
                  paymentTypeMap[method] === 3 ? chequeName : null,
                pay_cheque_branch:
                  paymentTypeMap[method] === 3
                    ? chequeBranch || "ธนาคารกสิกรไทย"
                    : null,
                pay_cheque_date:
                  paymentTypeMap[method] === 3
                    ? moment(chequeDate)
                      .utcOffset(7, true)
                      .format("YYYY-MM-DD HH:mm:ss.SSS")
                    : null,
                pay_cheque_type: null,
                comp_id: localStorage.getItem("company"),
                bank_master_id: bank_master_id_val,
                bank_id: bank_id_val,
                doc_ref: null,
              };

              // ส่งข้อมูลไปยัง API
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
                formPaymentHistoryData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
            }
          }

          // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
          if (paymentType.cash || paymentType.transfer || paymentType.cheque) {
            const getNewData = await getDataWithComp(
              "API_0701_SO_H",
              `AND Doc_ID = ${formMasterList.docId}`
            );
            if (getNewData && getNewData.length > 0) {
              const data = getNewData[0];
              if (data.Doc_Status_Paid_Type === 6) {
                const getPayHistory = await getData(
                  "Pay_History",
                  `DocCode_Id = 7 AND Doc_Id = ${docId}`
                );
                if (getPayHistory && getPayHistory.length > 0) {
                  for (const pay of getPayHistory) {
                    await manageWhArPaymentData(
                      data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                      data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                      data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                      0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                      "AI", // ประเภท เช่น AI/AO
                      parseCurrency(pay.Pay_Amount), // ค่าจำนวนเงิน
                      data.Doc_ID, // ไอดีเอกสาร
                      data.Doc_No, // เลขเอกสาร
                      data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
                      await setRemarkByPaymentType(parseCurrency(pay.Pay_Type)), // หมายเหตุ
                      parseCurrency(pay.Pay_Type) // ช่องทางการชำระ
                    );
                  }
                }
              } else {
                // ปรับยอดเงินออก
                await manageWhArPaymentData(
                  data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                  data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                  data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                  0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                  "AI", // ประเภท เช่น AI/AO
                  parseCurrency(data.Pay_Total), // ค่าจำนวนเงิน
                  data.Doc_ID, // ไอดีเอกสาร
                  data.Doc_No, // เลขเอกสาร
                  data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
                  await setRemarkByPaymentType(
                    parseCurrency(data.Doc_Status_Paid_Type)
                  ), // หมายเหตุ
                  parseCurrency(data.Doc_Status_Paid_Type) // ช่องทางการชำระ
                );
              }
            }
          }
        }
      }

      setIsLoading(false);
      setMode("S");
      callInitialize();

      if (mode === "I") {
        getAlert("OK", "บันทึกรายการใบขายสำเร็จ");
      } else {
        getAlert("OK", "แก้ไขรายการใบขายสำเร็จ");
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };
  // ใช้สำหรับปรับสถานะที่เป็น 'ค้างจ่าย' ให้เป็น 'จ่ายครบ' (เฉพาะเครดิต และ เช็ค)
  const handleUpdatePaidStatus = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);
      // ตรวจสอบช่องทางที่ถูกเลือก
      let docStatusPaidType = 6;
      const selectedMethods = Object.keys(paymentType).filter(
        (method) => paymentType[method]
      );

      if (selectedMethods.length === 1) {
        const method = selectedMethods[0];
        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          credit: 4,
          unpaid: 5,
        };
        docStatusPaidType = paymentTypeMap[method] || 6;
      }
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formUpdateData = {
        doc_status_paid: parseCurrency("3", 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
        doc_status_paid_type: parseCurrency(docStatusPaidType, 10),
      };
      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-paid-complete`,
        formUpdateData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );
      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        setMode("S");
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }

      setIsLoading(false);
      // handlePayTypeShow();
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
      const getOldData = await getDataWithComp(
        "API_0701_SO_H",
        `AND Doc_No = '${formMasterList.docNo}'`
      );
      if (
        getOldData &&
        getOldData.length > 0 &&
        getOldData[0].Doc_Status_Paid !== 3
      ) {
        const data = getOldData[0];

        const payAmount =
          parseCurrency(data.NetTotal) - parseCurrency(data.Pay_Total);

        // ปรับยอดเงินเข้า
        await manageWhArPaymentData(
          data.AR_ID, // AR_ID ของลูกค้านั้นๆ
          data.AR_Code, // AR_Code ของสิ่งนั้นๆ
          data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
          0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
          "CC", // ประเภท เช่น AI/AO/CC
          parseCurrency(payAmount), // ค่าจำนวนเงิน
          data.Doc_ID, // ไอดีเอกสาร
          data.Doc_No, // เลขเอกสาร
          data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
          `ยกเลิกใบขาย : ${data.Doc_No}`, // หมายเหตุ
          parseCurrency(data.Doc_Status_Paid_Type) // ช่องทางการชำระ
        );
      }

      // คืนสต็อกคลัง เมื่อทำการยกเลิก (คุณทรายแจ้งมา)
      const findOldDetail = await getDataWithComp(
        "API_0702_SO_D",
        `AND Doc_No = '${formMasterList.docNo}' ORDER By Line ASC`
      );
      if (findOldDetail && findOldDetail.length > 0) {
        for (const dataDetail of findOldDetail) {
          // ย้ายเข้า
          await manageWhItemData(
            dataDetail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
            dataDetail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
            dataDetail.Item_Name, // ชื่อ Item นั้นๆ
            dataDetail.WH_Id, // WarehouseID ของไอเทม
            "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            parseCurrency(dataDetail.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
            dataDetail.Doc_ID, // ไอดีเอกสาร
            dataDetail.Doc_No, // เลขเอกสาร
            dataDetail.Ref_Doc === null
              ? dataDetail.Doc_No
              : dataDetail.Ref_Doc, // เลขเอกสารอ้างอิง
            `ยกเลิกใบ : ${dataDetail.Doc_No}` // หมายเหตุ
          );
        }
      }

      // ทำการคืนถังด้วย (กรณีที่มีถัง)
      if (localStorage.getItem("company") === "1") {
        // => ยกเลิก
        // ย้อนคืน -5 AO (WHERE หา AI Doc_No ORDER BY DESC ล่าสุด ก็จะได้ +5) = -8
        // ย้อนขาย +3 AI (WHERE หา AO Doc_No  ORDER BY DESC ล่าสุด ก็จะได้ +3) = -8 + 3 = -5
        const getSoDetailList = await getDataWithComp(
          "API_0702_SO_D",
          `AND Doc_No = '${formMasterList.docNo}' ORDER By Line ASC`
        );
        if (getSoDetailList && getSoDetailList.length > 0) {
          for (const soDetail of getSoDetailList) {
            // #####################################
            // คืนถังตามจำนวนสินค้าที่เป็นน้ำเติม
            // #####################################
            if (Number(soDetail.Item_Id) === 1409) {
              const getItemRemainStcForAi = await getDataWithComp(
                "ITEM_Remain_STC",
                `AND Item_Id = '${formMasterList.arID}' AND Doc_Id = '${soDetail.Doc_ID}' AND Doc_Type = 'AI' ORDER BY STC_SEQ DESC`
              );
              if (getItemRemainStcForAi && getItemRemainStcForAi.length > 0) {
                const itemRemainStc = getItemRemainStcForAi[0];
                await manageItemRemainData(
                  soDetail.AR_ID, // AR_ID
                  soDetail.AR_Code, // AR_Code
                  soDetail.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                  0, // WarehouseID
                  "AI", // ประเภท
                  parseCurrency(itemRemainStc.STC_QTY), // จำนวนชิ้นที่ปรับ
                  soDetail.Doc_ID, // ไอดีเอกสาร
                  soDetail.Doc_No, // เลขเอกสาร
                  soDetail.Doc_No, // เลขเอกสารอ้างอิง
                  null // หมายเหตุ
                );
                setTimeout(async () => {
                  await manageItemRemainData(
                    soDetail.AR_ID, // AR_ID
                    soDetail.AR_Code, // AR_Code
                    soDetail.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                    0, // WarehouseID
                    "AO", // ประเภท
                    parseCurrency(soDetail.Item_Qty), // จำนวนชิ้นที่ปรับ
                    soDetail.Doc_ID, // ไอดีเอกสาร
                    soDetail.Doc_No, // เลขเอกสาร
                    soDetail.Doc_No, // เลขเอกสารอ้างอิง
                    `ยกเลิกใบขาย : ${soDetail.Doc_No}` // หมายเหตุ
                  );
                }, 1000);
              }
            }
          }
        }
      }

      setMode("S");
      callInitialize();
      getAlert(response.data.status, response.data.message);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdateSlip = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        if (!item.whId) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        }
      }

      // จัดการการอัพโหลดสลิป
      if (paymentType.transfer) {
        try {
          setIsUploadingSlips(true);

          if (multipleSlipImages && multipleSlipImages.length > 0) {
            const slipFiles = multipleSlipImages.map((image) => image.base64);
            await uploadMultipleSlips(slipFiles, formMasterList.docId, 7);
          } else if (base64Image) {
            await uploadSlip(base64Image, formMasterList.docId, 7);
          }
        } catch (uploadError) {
          console.error("❌ Error uploading slips:", uploadError);
          getAlert(
            "WARNING",
            "บันทึกข้อมูลสำเร็จ แต่การอัพโหลดสลิปมีปัญหา: " +
            uploadError.message
          );
        } finally {
          setIsUploadingSlips(false);
        }
      }
      setMode("S");
      callInitialize();
      getAlert("OK", "อัพโหลดสลิปเรียบร้อยแล้ว");
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? newValue : null,
    }));
  };

  const handleChangeDetail = async (index, field, value) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    if (field === "itemQty") {
      setIsEditDetail(true);
    }

    if (
      field === "itemQty" &&
      (formDetailList[index].itemOnHand === null ||
        formDetailList[index].itemOnHand === undefined)
    ) {
      getAlert("FAILED", "กรุณาเลือกคลังก่อน");
      return;
    }

    // คำนวณ itemQty และ itemTotal ก่อนที่จะเช็คว่าจำนวนเกินคลังหรือไม่
    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;

    itemTotal -= itemDisType === "2" ? (itemDiscount / 100) * itemTotal : itemDiscount;

    // เงื่อนไขการตรวจสอบจำนวนเกินคลัง
    if (
      field === "itemQty" &&
      parseCurrency(value) > parseCurrency(formDetailList[index].itemOnHand)
    ) {
      updatedList[index].itemQty = parseCurrency(
        formDetailList[index].itemOnHand
      );
      setTimeout(() => {
        handleBlur(
          index,
          "itemQty",
          String(parseCurrency(formDetailList[index].itemOnHand))
        );
      }, 0);
      getAlert("FAILED", "ไม่สามารถใส่จำนวนเกินกว่าจำนวนคงคลังได้");
      itemTotal = parseCurrency(formDetailList[index].itemOnHand) * itemPriceUnit;
      itemTotal -= itemDisType === "2" ? (itemDiscount / 100) * itemTotal : itemDiscount;
    }

    updatedList[index].itemTotal = itemTotal;

    if (field === "whId") {
      updatedList[index].itemOnHand = "-";

      const [itemOnHand] = await Promise.all([
        getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND WH_Id = ${parseCurrency(value)} AND Item_Id = ${updatedList[index].itemId
          }`
        ),
      ]);

      let newItemOnHand = 0;
      if (itemOnHand && itemOnHand.length > 0) {
        newItemOnHand = parseCurrency(itemOnHand[0].Item_Onhand);
      }

      updatedList[index].itemOnHand = newItemOnHand;

      // คำนวณ itemTotal ใหม่หลังจาก update itemOnHand
      const updatedItemQty = parseCurrency(updatedList[index].itemQty) || 0;
      itemTotal = updatedItemQty * itemPriceUnit;
      itemTotal -=
        itemDisType === "2" ? (itemDiscount / 100) * itemTotal : itemDiscount;
      updatedList[index].itemTotal = itemTotal;
    }

    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] =
      parseCurrency(updatedList[index][field].replace(/,/g, "")) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // SET QT
  const [showQtModal, setShowQtModal] = useState(false);
  const handleQtShow = () => setShowQtModal(true);
  const handleQtClose = () => setShowQtModal(false);
  const onRowSelectQt = async (qtSelected) => {
    try {
      // เคลียร์ค่าใน formMasterList และ formDetailList
      setFormMasterList({});
      setFormDetailList([]);

      // ค้นหาข้อมูลที่ตรงกับ prSelected.Doc_No ใน PR_H และ AP_ID ใน apDataList
      const [fromViewMaster, fromViewAr] = await Promise.all([
        getDataWithComp("API_0601_QT_H", "ORDER BY Doc_No DESC"),
        arDataList.find((ar) => ar.AR_Id === qtSelected.AR_ID),
      ]);

      const fromViewQt = fromViewMaster.find(
        (qt) => qt.Doc_No === qtSelected.Doc_No
      );

      if (!fromViewQt || !fromViewAr) {
        throw new Error("ไม่พบข้อมูล");
      }

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;

        if (itemSelected.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        return {
          ...soDetailModel(index + 1),
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
        };
      };

      const getAllItem = await getDataWithComp(
        "API_0602_QT_D",
        "ORDER BY Line ASC"
      );
      const filterItem = getAllItem.filter(
        (item) => item.Doc_No === qtSelected.Doc_No
      );

      if (filterItem.length > 0) {
        const newFormDetails = filterItem.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);

        const firstItem = filterItem[0];

        setFormMasterList({
          ...formMasterList,
          refDocID: fromViewQt.Doc_ID,
          refDoc: fromViewQt.Doc_No,
          refDocDate: convertDate(fromViewQt.Doc_Date, false),
          docDate: moment()
            .utcOffset(7, true)
            .format("YYYY-MM-DD HH:mm:ss.SSS"),
          docDueDate: moment()
            .utcOffset(7, true)
            .format("YYYY-MM-DD HH:mm:ss.SSS"),
          docRemark1: fromViewQt.Doc_Remark1,
          docRemark2: fromViewQt.Doc_Remark2,
          docType: fromViewQt.Doc_Type,
          docFor: fromViewQt.Doc_For,
          transportType: fromViewQt.Transport_Type,
          discountValue: fromViewQt.Discount_Value,
          creditTerm: firstItem.CreditTerm,
          arID: fromViewQt.AR_ID,
          arCode: firstItem.AR_Code,
          arName: firstItem.AR_Name,
          arAdd1: firstItem.AR_Add1,
          arAdd2: firstItem.AR_Add2,
          arAdd3: firstItem.AR_Add3,
          arProvince: firstItem.AR_Province,
          arZipcode: firstItem.AR_Zipcode,
          arTaxNo: firstItem.AR_TaxNo,
          arItemFree: firstItem.AR_Item_Free,
        });

        setIsVatChecked(fromViewQt.IsVat === 1 ? true : false);

        const discountValueType = parseCurrency(fromViewQt.Discount_Value_Type);
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${qtSelected.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }

      handleQtClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
        arItemFree: arSelected.AR_Item_Free,
      });

      // ถ้าลูกค้ามี VAT ให้ Default VAT
      if (parseCurrency(arSelected.AR_Vat) === 1) {
        setIsVatChecked(true);
      }

      if (arSelected.AR_Item_Free === "Y") {
        if (formDetailList.length > 0) {
          setFormDetailList([]);
          getAlert(
            "INFO",
            "ลูกค้านี้เป็นลูกค้าฟรี ระบบจะล้างข้อมูลรายการสินค้าโดยอัตโนมัติ"
          );
        }
      }

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => {
    if (formMasterList.arID === null) {
      getAlert("FAILED", "กรุณาเลือกลูกค้า");
      return;
    }

    setShowItemModal(true);
  };
  const handleItemClose = () => setShowItemModal(false);
  const getCustomerSpecificPrices = async (itemsSelected) => {
    const compId = window.localStorage.getItem("company");
    const arId = formMasterList?.arID;

    if (
      compId !== "1" ||
      !arId ||
      !Array.isArray(itemsSelected) ||
      itemsSelected.length === 0
    ) {
      return {};
    }

    const uniqueItemIds = [
      ...new Set(
        itemsSelected
          .map((item) => {
            const parsed = parseInt(item?.Item_Id, 10);
            return Number.isNaN(parsed) ? null : parsed;
          })
          .filter((id) => id !== null)
      ),
    ];

    if (uniqueItemIds.length === 0) {
      return {};
    }

    const itemCondition =
      uniqueItemIds.length === 1
        ? `AND Item_Id = ${uniqueItemIds[0]}`
        : `AND Item_Id IN (${uniqueItemIds.join(",")})`;

    try {
      const response = await getDataWithComp(
        "Tb_Set_Item_Price",
        `AND Comp_Id = ${compId} AND AR_Id = ${arId} ${itemCondition}`
      );

      if (!Array.isArray(response)) {
        return {};
      }

      return response.reduce((acc, row) => {
        if (row?.Item_Id == null) {
          return acc;
        }

        const numericPrice = Number(row.Item_Price);
        if (Number.isNaN(numericPrice)) {
          return acc;
        }

        acc[String(row.Item_Id)] = numericPrice;
        return acc;
      }, {});
    } catch {
      return {};
    }
  };
  const onRowSelectItem = async (itemsSelected) => {
    try {
      if (!Array.isArray(itemsSelected) || itemsSelected.length === 0) {
        handleItemClose();
        return;
      }

      let defaultWhId =
        mode === "U" && formDetailList.length > 0
          ? formDetailList.find((item) => item.whId !== null)?.whId || null
          : null;

      if (window.localStorage.getItem("company") === "2") {
        defaultWhId = "2";
      }

      const priceByItem = await getCustomerSpecificPrices(itemsSelected);

      const updatedItems = await Promise.all(
        itemsSelected.map(async (itemSelected) => {
          let itemOnHand = formatCurrency(0);

          if (mode === "U" && defaultWhId !== null) {
            const [result] = await Promise.all([
              getDataWithComp(
                "API_1101_WH_ITEM_ONHAND",
                `AND WH_Id = ${parseCurrency(defaultWhId)} AND Item_Id = ${itemSelected.Item_Id
                }`
              ),
            ]);

            if (result && result.length > 0) {
              itemOnHand = parseCurrency(result[0].Item_Onhand);
            }
          }

          let itemPriceUnitForIce = await getPriceForIce(
            formMasterList.arCode,
            itemSelected.Item_Code,
            0
          );

          const isSalePrice = itemPriceType === "IP";
          const companyId = window.localStorage.getItem("company");
          const defaultPrice = isSalePrice
            ? companyId === "2"
              ? itemPriceUnitForIce
              : itemSelected.Item_Price
            : itemSelected.Item_Wholesale_price || 0;
          const parsedDefaultPrice = parseCurrency(defaultPrice) || 0;
          const overridePrice = priceByItem[String(itemSelected.Item_Id)];
          const resolvedPrice =
            typeof overridePrice === "number" && !Number.isNaN(overridePrice)
              ? overridePrice
              : parsedDefaultPrice;

          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(resolvedPrice),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemSelected.Item_Status,
            whId: mode === "I" ? null : defaultWhId,
            itemOnHand: itemOnHand,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
          };
        })
      );

      if (window.localStorage.getItem("company") === "2") {
        for (let i = 0; i < updatedItems.length; i++) {
          const it = updatedItems[i];
          it.whId = "2";
          try {
            const [result] = await Promise.all([
              getDataWithComp(
                "API_1101_WH_ITEM_ONHAND",
                `AND WH_Id = ${parseCurrency(2)} AND Item_Id = ${it.itemId}`
              ),
            ]);

            if (result && result.length > 0) {
              it.itemOnHand = parseCurrency(result[0].Item_Onhand);
            } else {
              it.itemOnHand = formatCurrency(0);
            }
          } catch (err) {
            it.itemOnHand = formatCurrency(0);
          }
        }
      }

      setFormDetailList([...formDetailList, ...updatedItems]);
      setIsEditDetail(true);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const handleDuplicateRow = (index) => {
    const newItem = { ...formDetailList[index] };
    const newList = [
      ...formDetailList.slice(0, index + 1),
      newItem,
      ...formDetailList.slice(index + 1),
    ];
    setIsEditDetail(true);
    setFormDetailList(newList);
  };
  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setIsEditDetail(true);
      setFormDetailList(newList);
    }, 50);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // SET WAREHOUSE
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const handleWarehouseShow = () => setShowWarehouseModal(true);
  const handleWarehouseClose = () => setShowWarehouseModal(false);
  const onRowSelectWh = async (whSelected) => {
    // สำหรับ Freeze หน้าจอตอนทำรายการ
    setIsLoading(true);

    handleWarehouseClose();

    if (formDetailList && formDetailList.length > 0) {
      for (let index = 0; index < formDetailList.length; index++) {
        handleChangeDetail(index, "whId", whSelected.WH_Id);
      }
    } else {
      setIsLoading(false);
      getAlert("FAILED", "กรุณาเลือกสินค้าก่อน");
    }

    setIsLoading(false);
  };

  const checkPayment = async () => {
    const totalPaidAmount =
      (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
      (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
      (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0) +
      (paymentType.credit ? parseCurrency(paymentAmount.credit) : 0) +
      (paymentType.unpaid ? parseCurrency(paymentAmount.unpaid) : 0);

    if (parseCurrency(totalPaidAmount) === 0) {
      getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
      setIsLoading(false);
      return;
    }

    // if (parseCurrency(totalPaidAmount) > parseCurrency(grandTotal)) {
    //   getAlert("FAILED", "กรุณาระบุยอดการชำระเงินไม่เกินกว่าที่ต้องชำระเงิน");
    //   setIsLoading(false);
    //   return;
    // }

    await setShowConfirmModal(true);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let isMounted = true;
    const fetchDiscount = async () => {
      const discountValue = parseCurrency(formMasterList.discountValue || 0);
      let nextReceiptDiscount = 0;

      if (localStorage.getItem("company") === "2") {
        if (selectedDiscountValueType === "1") {
          nextReceiptDiscount = parseCurrency(discountValue || 0);
        } else if (selectedDiscountValueType === "2") {
          nextReceiptDiscount = parseCurrency(((totalPrice * discountValue) / 100) || 0);
        } else {
          const getDiscount = await getDiscountForIce(formDetailList, formMasterList.arID);
          nextReceiptDiscount = parseCurrency(getDiscount || 0);
        }
      } else {
        if (selectedDiscountValueType === "2") {
          // เปอร์เซ็นต์
          nextReceiptDiscount = (totalPrice * discountValue) / 100;
        } else if (selectedDiscountValueType === "1") {
          // จำนวนเงิน
          nextReceiptDiscount = discountValue;
        }
        nextReceiptDiscount = parseCurrency(nextReceiptDiscount || 0);
      }

      // อัพเดตเฉพาะเมื่อค่าเปลี่ยนจริง ๆ เพื่อลดการ re-render
      if (isMounted && parseCurrency(receiptDiscount) !== nextReceiptDiscount) {
        setReceiptDiscount(nextReceiptDiscount);
      }
    };

    fetchDiscount();
    return () => {
      isMounted = false;
    };

  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType, formDetailList, formMasterList.arID]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  return (
    <>
      <div
        hidden={
          window.location.pathname === "/bill" ||
          window.location.pathname === "/picking-list" ||
          window.location.pathname === "/quotation"
        }
      >
        <Breadcrumbs
          page={maxDocNo}
          isShowStatus={mode === "U"}
          statusName={
            parseCurrency(formMasterList.docStatus) === 13
              ? "ยกเลิก"
              : statusTransportName
          }
          statusColour={
            parseCurrency(formMasterList.docStatus) === 13
              ? "black"
              : statusTransportColour
          }
          otherStatusName={statusPaidName}
          otherStatusColour={statusPaidColour}
          otherTypeName={statusPaidTypeName}
          otherTypeColour={statusPaidTypeColour}
          items={[
            { name: "ขายสินค้า", url: "/sellproducts" },
            { name: name, url: "/billofsale" },
            {
              name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name,
              url: "#",
            },
          ]}
          docIsINV={formMasterList.docIsInv}
          onHandleClick={() => getReport("so", formMasterList.docNo)}
          onHandlePayslip={() => getReport("rc", formMasterList.docNo)}
          onHandleInvoice1={() => getReport("inv1", formMasterList.docInvNo)}
          onHandleInvoice2={() => getReport("inv2", formMasterList.docInvNo)}
          onHandleInvoice3={() => getReport("so_receipt", formMasterList.docNo)}
          urlImg={slipImage}
          handleUploadSlip={handleUploadSlip}
          base64Image={base64Image}
          setBase64Image={setBase64Image}
          handleUpdateSlip={handleUpdateSlip}
          docInvNo={formMasterList.docInvNo}
          isVatChecked={isVatChecked}
        />
      </div>

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 2147483647 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div className="hidden-scrollbar" style={{ overflowY: "auto" }}>
        <div className="row mt-1">
          <div className="col-3 text-left">
            <DatePicker
              label="วันที่เอกสาร"
              name="docDate"
              value={formMasterList.docDate}
              onChange={(date) => handleChangeDateMaster(date, "docDate")}
              disabled={
                formMasterList.docStatusPaid === 3 ||
                  window.location.pathname === "/bill" ||
                  window.location.pathname === "/quotation"
                  ? true
                  : false
              }
            />
          </div>
          <div className="col-4 text-left">
            <div className="d-flex align-items-center">
              <label>ลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.arCode || "") +
                    " " +
                    (formMasterList.arName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleArShow}
                  disabled={mode === "U" ? true : false}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ArModal
              showArModal={showArModal}
              handleArClose={handleArClose}
              arDataList={arDataList}
              onRowSelectAr={onRowSelectAr}
            />
          </div>
          <div className="col-2"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDoc"
                  value={formMasterList.refDoc || ""}
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleQtShow}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <QtModal
                showQtModal={showQtModal}
                handleQtClose={handleQtClose}
                qtDataList={qtDataList}
                onRowSelectQt={onRowSelectQt}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList.arAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="วันที่เอกสารอ้างอิง"
              name="refDocDate"
              value={formMasterList.refDocDate}
              onChange={(date) => handleChangeDateMaster(date, "refDocDate")}
              disabled={true}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arAdd2 || "") +
                  " " +
                  (formMasterList.arAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill" ||
                    window.location.pathname === "/quotation"
                    ? true
                    : false
                }
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arProvince || "") +
                  " " +
                  (formMasterList.arZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>วัตถุประสงค์</label>
            <select
              name="docFor"
              value={formMasterList.docFor}
              onChange={handleChangeMaster}
              className="form-select form-control input-spacing"
              disabled={
                formMasterList.docStatusPaid === 3 ||
                  window.location.pathname === "/bill"
                  ? true
                  : false
              }
            >
              <option value="1">ซื้อมาเพื่อใช้</option>
              <option value="2">ซื้อมาเพื่อขาย</option>
            </select>
          </div> */}
            <DatePicker
              label="Due Date"
              name="docDueDate"
              value={formMasterList.docDueDate}
              onChange={(date) => handleChangeDateMaster(date, "docDueDate")}
              disabled={
                formMasterList.docStatusPaid === 3 ||
                  window.location.pathname === "/bill"
                  ? true
                  : false
              }
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.arTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex">
              <label>ผู้ทำการขาย</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="invCode"
                  value={
                    (formMasterList.invCode || "") +
                    " " +
                    (formMasterList.invName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleEmpShow}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <EmployeeModal
                showEmpModal={showEmpModal}
                handleEmpClose={handleEmpClose}
                empDataList={empDataList}
                onRowSelectEmp={onRowSelectEmp}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3"></div>
          <div className="col-6" />
          <div className="col-3 text-right">
            {/* <div className="d-flex align-items-center">
            <label>ผู้อนุมัติเอกสาร</label>
            <input
              type="text"
              className="form-control input-spacing"
              name="approvedByName"
              value={formMasterList.approvedByName || ""}
              onChange={handleChangeMaster}
              disabled={true}
            />
          </div> */}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วิธีจัดส่ง</label>
              <select
                name="transportType"
                value={formMasterList.transportType}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill" ||
                    window.location.pathname === "/quotation"
                    ? true
                    : false
                }
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเลขบิล</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refBillNo"
                onChange={handleChangeMaster}
                value={formMasterList.refBillNo || ""}
                disabled={
                  parseCurrency(formMasterList.docStatus) === 13 ||
                    window.location.pathname === "/quotation"
                    ? true
                    : false
                }
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>แผนก</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={invDeptName || ""}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                maxLength={100}
                disabled={
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill" ||
                    window.location.pathname === "/quotation"
                    ? true
                    : false
                }
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                maxLength={500}
                disabled={
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill" ||
                    window.location.pathname === "/quotation"
                    ? true
                    : false
                }
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <ItemForSaleTable
            formDetailList={formDetailList}
            handleChangeDetail={handleChangeDetail}
            handleDuplicateRow={handleDuplicateRow}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            showWarehouseModal={showWarehouseModal}
            handleWarehouseClose={handleWarehouseClose}
            handleWarehouseShow={handleWarehouseShow}
            onRowSelectWh={onRowSelectWh}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabled={
              formMasterList.docStatusPaid === 3 ||
                window.location.pathname === "/bill" ||
                window.location.pathname === "/quotation"
                ? true
                : false
            }
            mode={mode}
            itemPriceType={itemPriceType}
            setItemPriceType={setItemPriceType}
          />
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={
              formMasterList.docStatusPaid === 3 ||
                window.location.pathname === "/bill" ||
                window.location.pathname === "/quotation"
                ? true
                : false
            }
            disabledVat={mode === "U"}
          />
          <div
            hidden={
              window.location.pathname === "/bill" ||
              window.location.pathname === "/picking-list"
            }
          >
            <PaymentModal
              mode={mode}
              show={showPayTypeModal}
              grandTotal={grandTotal}
              paymentType={paymentType}
              setPaymentType={setPaymentType}
              paymentAmount={paymentAmount}
              setPaymentAmount={setPaymentAmount}
              payDatetime={payDatetime}
              setPayDatetime={setPayDatetime}
              handlePayTypeClose={handlePayTypeClose}
              handleUpdatePayment={handleUpdatePayment}
              handleUploadSlip={handleUploadSlip}
              base64Image={base64Image}
              setBase64Image={setBase64Image}
              chequeNo={chequeNo}
              setChequeNo={setChequeNo}
              chequeName={chequeName}
              setChequeName={setChequeName}
              chequeBranch={chequeBranch}
              setChequeBranch={setChequeBranch}
              chequeDate={chequeDate}
              setChequeDate={setChequeDate}
              bankMasterId={bankMasterId}
              setBankMasterId={setBankMasterId}
              bankInputMode={bankInputMode}
              setBankInputMode={setBankInputMode}
              payToAccNo={payToAccNo}
              setPayToAccNo={setPayToAccNo}
              payToAccName={payToAccName}
              setPayToAccName={setPayToAccName}
              bankId={bankId}
              setBankId={setBankId}
              showConfirmModal={showConfirmModal}
              setShowConfirmModal={setShowConfirmModal}
              checkPayment={checkPayment}
              isAllowCredit={isAllowCredit}
              docId={formMasterList.docId}
              docCodeId={7} // 7 คือ DocCode_Id สำหรับ SO
              multipleSlipImages={multipleSlipImages}
              setMultipleSlipImages={setMultipleSlipImages}
              handleMultipleSlipUpload={handleMultipleSlipUpload}
              handleRemoveSlipImage={handleRemoveSlipImage}
              handleClearAllSlips={handleClearAllSlips}
              isUploadingSlips={isUploadingSlips}
            />
          </div>
        </div>
      </div>

      {window.location.pathname !== "/quotation" && (
        <FormAction
          onSubmit={async () => {
            if (await validateData()) {
              if (
                parseCurrency(grandTotal) === 0 &&
                formMasterList.arItemFree !== "Y"
              ) {
                getAlert(
                  "FAILED",
                  "กรุณาเพิ่มรายการ หรือ ใส่จำนวนเงินก่อนบันทึก"
                );
              } else if (formMasterList.arItemFree !== "Y") {
                setShowPayTypeModal(true);
              } else {
                if (formMasterList.arItemFree === "Y") {
                  setShowConfirmModal(true);
                } else {
                  setShowPayTypeModal(true);
                }
              }
            }
          }}
          onUpdate={async () => {
            if (await validateData()) {
              if (
                Number(formMasterList.docStatusPaid) === 3 ||
                Number(formMasterList.docStatusPaidType) === 4
              ) {
                await handleUpdate();
              } else {
                setShowPayTypeModal(true);
              }
            }
          }}
          onCancel={handleCancel}
          onApprovedPay={handlePayTypeShow}
          onUpdatePaid={handleUpdatePaidStatus}
          docStatus={formMasterList.docStatusPaid}
          mode={mode}
          setMode={setMode}
          disabled={
            parseCurrency(formMasterList.docStatus) === 13 ? true : false
          }
          disabledInv={formMasterList.docIsInv === "Y" ? true : false}
          disabledPay={isBl}
          creditCustomer={paymentType.credit}
          footer={true}
        />
      )}

      {/* Confirm Modal */}
      <div
        className={`modal fade ${showConfirmModal ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: showConfirmModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">ยืนยันการบันทึก</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowConfirmModal(false)}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>คุณแน่ใจว่าต้องการบันทึกข้อมูลใบขายหรือไม่?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white d-flex align-items-center justify-content-center"
                style={{ backgroundColor: "#EF6C00", fontSize: "16px" }}
                onClick={async () => {
                  setShowConfirmModal(false);
                  if (formMasterList?.arItemFree === "Y") {
                    await handleSubmit(0, 0, 0);
                    await callInitialize();
                    getAlert("OK", "บันทึกข้อมูลใบขายสำเร็จ");
                  } else {
                    await handleUpdatePayment();
                  }
                }}
                disabled={isSubmitting}
              >
                ยืนยัน
              </button>
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white"
                style={{ backgroundColor: "red", fontSize: "16px" }}
                onClick={() => setShowConfirmModal(false)}
                disabled={isSubmitting}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Form;
